import React, { useEffect, useState } from "react";
import { Form, Row, Input, Radio, Col, Button, Checkbox } from "antd";
import config from "../../config/form.json";
import SectionHeading from "./section-headings";
import EEFCFileupload from "../onboarding/eefcDoc";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { inwardPartner, orgmode, showloader } from "../../store/gloabalState";
import {
  getOrgCDocs,
  activeOrg,
  getBankNew,
  updateOrg,
} from "../../services/httpCalls";
import { handleFinish } from "../../utils/onboarding/inward-details/handle-finish";
import Cookies from "js-cookie";
import useNotify from "../../utils/useNotify";
import { useNavigate } from "react-router-dom";
import { inwardCurrencies } from "../../config/globalVar";
import { Tab, Tabs, Box } from "@mui/material";

const InwardDetails = ({ handleChange, orgDetails }) => {
  // * initializing form
  const [form] = Form.useForm();

  // * getting inward details config data
  const configData = config.inwardDetails[0];

  // * local states
  const [iseefc, setIsEeffc] = useState(false);
  const [editBank, setEditBank] = useState(false);
  const [editBankId, setEditBankId] = useState();
  const [refreshEEFC, setRefreshEEFC] = useState(false);
  const [alreadyUploadedEEFC, setAlreadyUploadedEEFC] = useState({
    EEFC_BANK_ACCOUNT_STATEMENT: false,
  });
  const [uploadedEEFCFileList, setUploadedEEFCFileList] = useState({
    EEFC_BANK_ACCOUNT_STATEMENT: "",
  });
  const [currenciesList, setCurrenciesList] = useState();
  const [localPartner, setLocalPartner] = useState("xflow");
  const [value, setValue] = useState(0);

  // * global states
  const partnerState = useRecoilValue(inwardPartner);

  // * values
  const mode = useRecoilValue(orgmode);

  // * setter/updater
  const setShowLoader = useSetRecoilState(showloader);

  // * states

  // * constants/binders
  const inwardCurrenciesInstance = inwardCurrencies;
  const navigate = useNavigate();
  const notify = useNotify();
  const variableCharges = new RegExp(/^(\d+|\d*\.\d+)$/);
  let docList_ = {
    EEFC_BANK_ACCOUNT_STATEMENT: false,
  };
  let uploadedFilesList_ = {
    EEFC_BANK_ACCOUNT_STATEMENT: "",
  };

  function isOpsUser() {
    try {
      const raw = Cookies.get("userInfo");
      if (!raw) return false;
      const info = JSON.parse(raw);
      return (
        typeof info?.userType === "string" &&
        info.userType.toUpperCase() === "OPS"
      );
    } catch {
      return false;
    }
  }

  useEffect(() => {
    let orgId = localStorage.getItem("orgId");
    let currenciesList_ = inwardCurrencies;
    let docList_ = {
      EEFC_BANK_ACCOUNT_STATEMENT: false,
    };
    let uploadedFilesList_ = {
      EEFC_BANK_ACCOUNT_STATEMENT: "",
    };
    getBankNew(orgId)
      .then((res) => {
        if (res.length) {
          res.forEach((elem) => {
            if (elem.status === "ACTIVE") {
              form.setFieldsValue({
                accountNumber: elem.accountNumber,
                bankName: elem.bankName,
                ifscCode: elem.ifscCode,
              });
              if (localPartner === "payglocal") {
                setIsEeffc(false);
              } else {
                if (elem.accountType === "EEFC") {
                  setIsEeffc(true);
                  form.setFieldsValue({
                    selectedInwardBankAccountType: true,
                  });
                } else {
                  setIsEeffc(false);
                  form.setFieldsValue({
                    selectedInwardBankAccountType: false,
                  });
                }
              }
              setEditBank(true);
              setEditBankId(elem.id);
            }
          });
        }
      })
      .finally(() => {
        setShowLoader(false);
      });
    if (orgDetails) {
      if (orgDetails?.initialCurrenciesForActivation?.currencies?.length) {
        orgDetails?.initialCurrenciesForActivation?.currencies?.forEach(
          (elem) => {
            currenciesList_.forEach((item) => {
              if (item.value.toLowerCase() === elem.toLowerCase()) {
                item.disabled = true;
              } else {
                delete item.disabled;
              }
            });
          }
        );
      } else {
        currenciesList_.forEach((item) => {
          delete item.disabled;
        });
      }
      setCurrenciesList(currenciesList_);
      if (localPartner === "payglocal") {
        orgDetails?.payglocalFees?.fees &&
          form.setFieldsValue({
            variableCharges:
              orgDetails?.payglocalFees?.fees[
                Object.keys(orgDetails?.payglocalFees?.fees)[0]
              ]?.percentageFee ?? 0,
            minimum:
              orgDetails?.payglocalFees?.fees[
                Object.keys(orgDetails?.payglocalFees?.fees)[0]
              ]?.minFee ?? 0,
            inwardHubspotDealId: orgDetails?.inwardHubspotDealId,
          });
        let currencies = [];
        let currenciesAmazon = [];
        if (orgDetails?.initialCurrenciesForActivation?.currencies) {
          currencies = orgDetails?.initialCurrenciesForActivation?.currencies;
        }
        if (orgDetails?.initialCurrenciesAmazonForActivation?.currencies) {
          currenciesAmazon =
            orgDetails?.initialCurrenciesAmazonForActivation?.currencies;
        }

        form.setFieldsValue({
          currenciesList: currencies,
          currenciesListAmazon: currenciesAmazon,
        });
        setCurrenciesList(currencies);
      } else {
        form.setFieldsValue({
          variableCharges: orgDetails?.feePlan?.payout[0].variable
            ? (orgDetails?.feePlan?.payout[0].variable / 1.18).toFixed(2)
            : 0,
          fxMarkupCharges: orgDetails?.feePlan?.payout_fx[0]?.variable
            ? (orgDetails?.feePlan?.payout_fx[0]?.variable / 1.18).toFixed(2)
            : 0,
          fixedCharges: orgDetails?.feePlan?.payout[0]?.fixed
            ? (orgDetails?.feePlan?.payout[0]?.fixed / 1.18).toFixed(4)
            : 0,
          minimum: orgDetails?.feePlan?.payout[0]?.minimum
            ? (orgDetails?.feePlan?.payout[0]?.minimum / 1.18).toFixed(4)
            : 0,
          inwardHubspotDealId: orgDetails?.inwardHubspotDealId,
          defaultCurrencies:
            orgDetails?.initialCurrenciesForActivation?.currencies,
        });
      }

      setAlreadyUploadedEEFC(docList_);
      setUploadedEEFCFileList(uploadedFilesList_);
      setShowLoader(false);
    }
  }, [localPartner]);

  useEffect(() => {
    let orgId = localStorage.getItem("orgId");
    getOrgCDocs(orgId)
      .then((res) => {
        if (res?.length) {
          let effc = res?.filter(
            (docs) => docs?.type === "EEFC_BANK_ACCOUNT_STATEMENT"
          );
          if (effc?.length) {
            effc?.forEach((effcs) => {
              if (effcs?.type === "EEFC_BANK_ACCOUNT_STATEMENT") {
                docList_["EEFC_BANK_ACCOUNT_STATEMENT"] = true;
                uploadedFilesList_["EEFC_BANK_ACCOUNT_STATEMENT"] =
                  effcs?.name?.split("~~")[1];
              }
            });
            setAlreadyUploadedEEFC(docList_);
            setUploadedEEFCFileList(uploadedFilesList_);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const finalSubmit = async (opts = {}) => {
    const isDraft = opts.__draft === true;
    let orgId = localStorage.getItem("orgId");
    let userId = Cookies.get("userId");
    let opsUserId = JSON.parse(Cookies.get("userInfo")).id;
    // If draft, skip activation
    if (isDraft) {
      try {
        await updateOrg(
          { accountSubmissionStatus: "DRAFT_SAVED_FOR_REVIEW_BY_OPS" },
          orgId
        ).then((res) => {
          if (res) {
            notify.success("Draft saved.");
          }
        });
      } catch (e) {
        console.log(e);
      }
      return;
    }
    // Only allow ops user to trigger activation
    if (!isOpsUser()) {
      if (partnerState?.length) {
        notify.info("Submission recorded. Awaiting ops activation.");
        return;
      }
    }
    setShowLoader(true);
    await activeOrg(orgId, userId, opsUserId)
      .then(async (res) => {
        if (res) {
          try {
            await updateOrg(
              { accountSubmissionStatus: "FINAL_SUBMISSION_DONE" },
              orgId
            );
          } catch (e) {
            console.log(e);
          }
          notify.success("Submitted success!");
        }
      })
      .finally(() => {
        setShowLoader(false);
      });
  };

  const handleFinishCall = async (values, isDraft = false) => {
    await handleFinish({
      mode,
      form,
      values,
      setShowLoader,
      editBank,
      editBankId,
      orgDetails,
      handleChange,
      finalSubmit,
      notify,
      navigate,
      partnerState,
      localPartner,
      value,
      setValue,
      setLocalPartner,
      isDraft,
    });
  };

  const handleAccountChange = (e) => {
    setIsEeffc(e.target?.value);
    form.resetFields(["isfcCode"]);
  };

  const handleTabChange = (event, newValue) => {
    if (mode === "view") {
      setValue(newValue);
      if (newValue === 0) {
        setLocalPartner("xflow");
      } else {
        setLocalPartner("payglocal");
      }
    }
  };

  useEffect(() => {
    if (partnerState.length) {
      if (partnerState.includes("xflow")) {
        setLocalPartner("xflow");
      } else {
        setLocalPartner("payglocal");
      }
    } else {
      setLocalPartner("xflow");
    }
  }, []);

  const renderField = (field, index) => {
    const { type, label, name, props, style, tooltip } = field;

    // * formatting rules
    field?.rules?.forEach((item) => {
      if (item?.pattern) {
        item.pattern = eval(item?.pattern);
      }
      if (item?.required) {
        item.required = eval(item?.required);
      }
      if (item?.validator) {
        item.validator = eval(item?.validator);
      }
    });

    switch (type) {
      case "Form.Item":
        return (
          <React.Fragment>
            <Form.Item
              label={label}
              name={name}
              rules={field?.rules}
              tooltip={tooltip}
              labelCol={field?.labelCol}
              required={eval(field?.required)}
              className={field?.className}
              disabled={field?.disabled}
            >
              {field?.children ? renderField(field?.children, 0) : null}
            </Form.Item>
            {field?.subFields
              ? field?.subFields.map((child, childIndex) =>
                  renderField(child, childIndex)
                )
              : null}
          </React.Fragment>
        );
      case "Input":
        return (
          <Input
            disabled={eval(props?.disabled)}
            readOnly={eval(props?.readOnly)}
            name={field?.name}
            onKeyUp={eval(props?.onKeyUp)}
            maxLength={props?.maxLength}
          />
        );
      case "SectionHeading":
        return (
          <SectionHeading
            style={field?.style}
            level={field?.level}
            heading={field?.heading}
            Col={field?.Col}
          />
        );
      case "Radio.Group":
        return (
          <Radio.Group
            onChange={eval(props?.onChange)}
            value={eval(props?.value)}
          >
            {field?.children?.map((child, childIndex) =>
              renderField(child, childIndex)
            )}
          </Radio.Group>
        );
      case "Radio":
        return (
          <Radio value={field?.value} style={field?.style}>
            {field?.label}
          </Radio>
        );
      case "EEFCFileupload":
        return (
          <EEFCFileupload
            name={field?.name}
            type={field?.subType}
            isUploaded={eval(props?.isUploaded)}
            uploadedList={eval(props?.uploadedList)}
            setRefreshEEFC={eval(props?.setRefreshEEFC)}
            refreshEEFC={eval(props?.refreshEEFC)}
          />
        );
      case "Checkbox.Group":
        return (
          <Checkbox.Group
            options={eval(props?.options)}
            disabled={eval(props?.disabled)}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div>
      {partnerState.length > 1 && (
        <Box sx={{ width: "20%" }} className="tabs_content">
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              className="tabs_wrap"
              value={value}
              aria-label="basic tabs example"
              onChange={handleTabChange}
            >
              <Tab label="Xflow/Banks" />
              <Tab label="Payglocal" />
            </Tabs>
          </Box>
        </Box>
      )}

      <Form
        {...configData.formConfig}
        form={form}
        className={mode === "view"}
        onFinish={handleFinishCall}
        disabled={mode === "view"}
      >
        <Row gutter={[16, 16]}>
          {configData.fields.map((field, index) => {
            // conditional render
            const shouldFileUploadRender = field.hasOwnProperty("iseefc")
              ? iseefc.toString() === field.iseefc.toString()
              : true;
            const conditionalLabel = field.hasOwnProperty("labelIseefc")
              ? iseefc.toString() === field.labelIseefc.toString()
              : true;
            const isPartnerPresent = field.hasOwnProperty("requiredForPartners")
              ? Boolean(partnerState.length)
                ? field?.requiredForPartners?.includes(localPartner)
                  ? true
                  : false
                : false
              : true;
            const shouldRender =
              shouldFileUploadRender &&
              conditionalLabel &&
              !field?.notPartner?.includes(localPartner) &&
              isPartnerPresent;

            return (
              shouldRender && (
                <Col key={index} span={field?.Col ? field.Col : 12}>
                  {renderField(field, index)}
                </Col>
              )
            );
          })}
        </Row>
        <div className="fixed_btn_wrap">
          <Button
            onClick={() =>
              handleChange(
                (orgDetails.companyType === "SOLE_PRORIETOR" ||
                  orgDetails.companyType === "FREELANCER") &&
                  partnerState.length === 1 &&
                  partnerState.includes("xflow")
                  ? 3
                  : 5
              )
            }
          >
            Previous
          </Button>
          {isOpsUser() && (
            <Button
              style={{ marginLeft: ".5rem" }}
              onClick={() => {
                const values = form.getFieldsValue(true);
                handleFinishCall(values, true);
              }}
            >
              Save as draft
            </Button>
          )}
          <Button
            type="primary"
            style={{ marginLeft: ".5rem" }}
            htmlType="submit"
            onClick={(values) =>
              form.getFieldValue("selectedInwardBankAccountType")
            }
          >
            {orgDetails?.isOptOutward === true ? "Next" : "Submit"}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default InwardDetails;

// TODO this may be used later
// {
//     "type": "Form.Item",
//     "name": "selectedInwardBankAccountType",
//     "rules": [
//         {
//             "required": true,
//             "message": "Please select account type!"
//         }
//     ],
//     "children": {
//         "type": "Radio.Group",
//         "style": {
//             "padding": 0,
//             "marginBottom": "10px"
//         },
//         "props": {
//             "onChange": "handleAccountChange"
//         },
//         "children": [
//             {
//                 "type": "Radio",
//                 "value": "Current",
//                 "label": "Current Account"
//             },
//             {
//                 "type": "Radio",
//                 "value": "Savings",
//                 "label": "Savings Account"
//             }
//         ]
//     },
//     "requiredForPartners":[
//         "payglocal"
//     ]
// },
